import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export const fncPopulateDepartments = ({commit, dispatch, state, rootState}, payload) => {
  if (state.departmentList == '' || (payload != undefined && payload.reload == true) || (payload != undefined && payload.refresh == true)) {
    var objAuth = JSON.parse(rootState.objAuthorize);
    var departmentDetails = {manu_id: objAuth.manufacturer};
    Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Department.php?a=retrieve', departmentDetails, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        console.log(error);
      }).then(data => {
      commit('setDepartmentalList', data);
      if (payload != undefined && payload.reload == true) {
        var snackDetails = {color: 'success', message: 'Department reload successfull', display: true};
        commit('setSnack', snackDetails);
      }
    });
  }
};
export const fncDepartmentDelete = ({commit, dispatch, state, rootState}, payload) => {
  var objAuth = JSON.parse(rootState.objAuthorize);
  var departmentDetails = {id: payload.departmentId};
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Department.php?a=remove', departmentDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
    console.log(data);
    if (data == 'success') {
      var snackDetails = {color: 'success', message: 'The department was removed successfully', display: true};
      commit('setSnack', snackDetails);
      commit('fncEmptyDepartments');
      dispatch({
        type: 'fncPopulateDepartments',
        refresh: true
      });
    } else {
      var snackDetails = {color: 'error', message: 'An error has occured removing the department', display: true};
      commit('setSnack', snackDetails);
    }
  });
};

export const fncAddDepartment = ({commit, dispatch, state, rootState}, payload) => {
  var objAuth = JSON.parse(rootState.objAuthorize);

  var departmentDetails = {
    params: {
      name: payload.departmentDetails.deparmentName,
      terms: payload.departmentDetails.terms,
      margin: payload.departmentDetails.departmentMargin,
      installation_margin: payload.departmentDetails.departmentInstallationMargin,
      ranges: payload.departmentDetails.departmentRanges,
      description: payload.departmentDetails.departmentDescription,
      extension: payload.departmentDetails.departmentExtension,
      branch: payload.departmentDetails.departmentBranch,
      address: payload.departmentDetails.departmentAddress,
      contactperson: payload.departmentDetails.departmentContactPerson,
      contactnumber: payload.departmentDetails.departmentContactNumber,
      email: payload.departmentDetails.departmentEmail,
      bank: payload.departmentDetails.departmentBank,
      // terms: payload.departmentDetails.departmentTnc,
      vendor: payload.departmentDetails.departmentVendor,
      product_codes: payload.departmentDetails.product_codes,
      override: payload.departmentDetails.departmentOverride == true ? 1 : 0,
      manufacturer: objAuth.manufacturer,
      user: objAuth.id,
      status_rules: payload.departmentDetails.statusRules,
      canAddRows: payload.departmentDetails.canAddRows,
      linkedItems: payload.departmentDetails.linkedItems,
      editForm: payload.departmentDetails.editForm,
      vendor: payload.departmentDetails.departmentVendor,
      special: payload.departmentDetails.special == true ? 1 : 0,
      dynamicMargin: payload.departmentDetails.dynamicMargin == true ? 1 : 0,
      margin: payload.departmentDetails.margin,
      margins: payload.departmentDetails.margins
    }
  }

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Department.php?a=add', departmentDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
    if (data == 'success') {
      commit('hideModal');
      var snackDetails = { color: 'success', message: 'The department was added successfully', display: true };
      commit('setSnack', snackDetails);
      commit('fncEmptyDepartments');
      dispatch({
        type: 'fncPopulateDepartments',
        refresh: true
      });
    } else {
      var snackDetails = { color: 'error', message: 'An error has occured adding the department', display: true };
      commit('setSnack', snackDetails);
    }
  });
};

export const fncUpdateDepartment = ({commit, dispatch, state, rootState}, payload) => {
  var objAuth = JSON.parse(rootState.objAuthorize);
  /*var regions = [];
  var userRegions = payload.departmentDetails.departmentRegions;
  for (var c in userRegions) {
    if (userRegions[c].selected == true) {
      regions.push(userRegions[c].loc_id);
    }
    for (var p in userRegions[c].children) {
      if (userRegions[c].children[p].selected == true) {
        regions.push(userRegions[c].children[p].loc_id);
      }
      for (var t in userRegions[c].children[p].children) {
        if (userRegions[c].children[p].children[t].selected == true) {
          regions.push(userRegions[c].children[p].children[t].loc_id);
        }
      }
    }
  }*/

  if (state.objDepartmentEdit.status_rules == null || state.objDepartmentEdit.status_rules == 'null') {
    var state_rules = [];
  } else {
    var state_rules = state.objDepartmentEdit.status_rules;
  }

  var departmentDetails = {
    params: {
      id: state.objDepartmentEdit.id,
      name: state.objDepartmentEdit.name,
      description: state.objDepartmentEdit.description,
      extension: state.objDepartmentEdit.extension,
      branch: state.objDepartmentEdit.branch,
      address: state.objDepartmentEdit.address,
      contactperson: state.objDepartmentEdit.contact_person,
      contactnumber: state.objDepartmentEdit.contact_number,
      email: state.objDepartmentEdit.email,
      bank: state.objDepartmentEdit.bank_details,
      terms: state.objDepartmentEdit.terms_and_conditions,
      margin: state.objDepartmentEdit.department_margin,
      installation_margin: state.objDepartmentEdit.department_installation_margin,
      override: state.objDepartmentEdit.bank_override == true ? 1 : 0,
      hide_quote_edit: state.objDepartmentEdit.hide_quote_edit == true ? 1 : 0,
      can_update_sales_margin: state.objDepartmentEdit.can_update_sales_margin == true ? 1 : 0,
      can_update_installation_margin: state.objDepartmentEdit.can_update_installation_margin == true ? 1 : 0,
      can_update_cost_price: state.objDepartmentEdit.can_update_cost_price == true ? 1 : 0,
      can_update_cost_price_installation: state.objDepartmentEdit.can_update_cost_price_installation == true ? 1 : 0,
      show_po_spec: state.objDepartmentEdit.show_po_spec == true ? 1 : 0,
      //regions: regions,
      user: objAuth.id,
      ranges: state.objDepartmentEdit.ranges,
      product_codes: JSON.stringify(state.objDepartmentEdit.product_codes),
      is_special: state.objDepartmentEdit.is_special == true ? 1 : 0,
      dynamic_margin: state.objDepartmentEdit.dynamic_margin == true ? 1 : 0,
      department_margin: state.objDepartmentEdit.department_margin,
      manufacturer: objAuth.manufacturer,
      status_rules: state_rules,
      widget_rules: state.objDepartmentEdit.widget_rules,
      installation_articles: state.objDepartmentEdit.installation_articles,
      delivery_note_template: state.objDepartmentEdit.delivery_note_template,
      article_margins: JSON.stringify(state.objDepartmentEdit.article_margins),
      canAddRows: state.objDepartmentEdit.can_add_rows,
      linkedItems: state.objDepartmentEdit.linked_items,
      editForm: state.objDepartmentEdit.edit_form_fields,
      margins: state.objDepartmentEdit.margins,
      app_starting_status: state.objDepartmentEdit.app_starting_status
      // status_rules: state.objDepartmentEdit.status_rules
    }
  }

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Department.php?a=update', departmentDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
    if (data == 'success') {
      commit('hideModal');
      var snackDetails = {color: 'success', message: 'The department was updated successfully', display: true};
      commit('setSnack', snackDetails);
      commit('fncEmptyDepartments');
      dispatch({
        type: 'fncPopulateDepartments',
        refresh: true
      });
    } else {
      var snackDetails = {color: 'error', message: 'An error has occured updating the department', display: true};
      commit('setSnack', snackDetails);
    }
  });
};

export const fncBranchRanges = ({commit, dispatch, state, rootState}, payload) => {


  var objAuth = JSON.parse(rootState.objAuthorize);

  Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = {color: 'error', message: 'An error has occured', display: true};
      commit('setSnack', snackDetails);
      console.log(error);
    }).then(data => {
    var tokenDetails = {
      token: data.token,
      manufacturer_key: objAuth.manufacturer,
      published_status: objAuth.module_spine_published,
      use_app_name: 0
    };
    Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/ranges', {params: tokenDetails}, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = {color: 'error', message: 'An error has occured', display: true};
        commit('setSnack', snackDetails);
        console.log(error);
      }).then(dt => {
      commit('setDepartmentRangesList', dt);

      if (payload == 'add') {
        var manuDetails = {manufacturer: objAuth.manufacturer};
      } else {
        var manuDetails = {manufacturer: objAuth.manufacturer, department: payload.departmentId};
      }
      Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Department.php?a=getDepartmentUsedRanges', manuDetails, rootState.headerDetails)
        .then(response => {
          return response.json();
        }, error => {
          console.log(error);
        }).then(ddt => {

        commit('setDepartmentUsedRanges', ddt);
        if (payload == 'add') {
          commit('setDepartmentLoader', false);
          /*var modalDetails = { title: 'Add Department', component: 'modal-department-add', mstate: true, params: {} };
          commit({
            type: 'setModal',
            details: modalDetails
          });*/
        } else {
          commit('setDepartmentLoader', false);
          /*var modalDetails = { title: 'Edit Department - ' + payload.departmentName, component: 'modal-department-edit', mstate: true };
          commit({
            type: 'setModal',
            details: modalDetails
          });*/
        }

      });

    });
  });
};

export const fncPopulateProductCodes = ({commit, dispatch, state, rootState}, payload) => {

  var objAuth = JSON.parse(rootState.objAuthorize);
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Department.php?a=retrieveCodes', {manu_id: objAuth.manufacturer}, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = {color: 'error', message: 'An error has occured', display: true};
      commit('setSnack', snackDetails);
      console.log(error);
    }).then(data => {
    commit('fncSetProductCodes', data);
  });
};

export const fncPopulateDepartmentUsers = ({commit, dispatch, state, rootState}, payload) => {
  var departmentDetails = {id: payload};
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Department.php?a=getUsers', departmentDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
    commit('setDepartmentUsers', data);
  });
};

export const fncPopulateDepartmentStatuses = ({commit, dispatch, state, rootState}, payload) => {
  var departmentDetails = {departmentId: payload.departmentId, manufacturer: payload.manufacturer};
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Department.php?a=getStatuses', departmentDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
    commit('setDepartmentStatuses', data);
  });
};

export const fncPopulateTallisman = ({ commit, dispatch, state, rootState }, payload) => {

  var objAuth = JSON.parse(rootState.objAuthorize);
  Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error has occured', display: true };
      commit('setSnack', snackDetails);
      console.log(error);
    }).then(data => {
    var tokenDetails = { token: data.token, id32: '486539909' };
    Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/line_items', { params: tokenDetails }, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = { color: 'error', message: 'An error has occured', display: true };
        commit('setSnack', snackDetails);
        console.log(error);
      }).then(items => {

      var lookupArray = [];

      if( items.length > 0 ) {
        for( var i in items ) {
          if( items[i].article_number != '' ) {
            if( lookupArray[items[i].article_number] == undefined ) {
              lookupArray[items[i].article_number] = []
            }
            var arrayLength = lookupArray[items[i].article_number].length;
            lookupArray[items[i].article_number].push( { code: items[i].code, description: items[i].description, p_key: items[i].property_key, v_key: items[i].value_key } );
          }
        }
      }

      commit( 'fncSetLookupArray', lookupArray );

    });
  });
};

export const fncUsableBranches = ({commit, dispatch, state, rootState}, payload) => {

  var objAuth = JSON.parse(rootState.objAuthorize);
  Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = {color: 'error', message: 'An error has occured', display: true};
      commit('setSnack', snackDetails);
      console.log(error);
    }).then(data => {
    var tokenDetails = {
      token: data.token,
      manufacturer_key: objAuth.manufacturer,
      published_status: objAuth.module_spine_published,
      use_app_name: 0
    };
    Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/ranges', {params: tokenDetails}, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = {color: 'error', message: 'An error has occured', display: true};
        commit('setSnack', snackDetails);
        console.log(error);
      }).then(dt => {
      commit('setDepartmentRangesList', dt);
    });
  });
};
